import React from 'react';
import "../styles/Registration.css";

const Registration = () => {
  return (
    <section className="registrationR">
      <p className="session-textR">SESSION 2026-27</p>
      <div className="registration-linksR">
        <a href="/admissionForm" className="registration-linkR student-linkR">
          Admission Open! -( Apply Now )
        </a>
        <a href="/hiring" className="registration-linkR teacher-linkR">
          Be a Part of Our Institution -(Apply Now)
        </a>
      </div>
    </section>
  );
};

export default Registration;
